<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="规格搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入商家编码/规格名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="apiSpecId"
            label="规格ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiSpecNo"
            label="商家编码">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiSpecName"
            label="规格名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiSpecPrice"
            label="零售价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiMarketPrice"
            label="划线价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiStockNum"
            label="库存">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiWeight"
            label="重量(kg)">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiLength"
            label="长(cm)">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiWidth"
            label="宽(cm)">
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiHeight"
            label="高(cm)">
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryPlatformGoodsSpecPageList } from '@/api/goods'
export default {
  name: 'ShopPlatformDetail',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      dataId:this.$route.query.dataId,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let apiGoodsId = that.dataId
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryPlatformGoodsSpecPageList({ apiGoodsId: apiGoodsId, searchStr: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/platform/Detail.vue